import { useCallback } from 'react';

import { useGetReportPreferencesQuery, useSaveReportPreferencesQuery } from '../queries';
import { PreferencesResponseDTO } from '../queries/useReportPreferences.query';

const useReportPreferencesHandler = () => {
  const { handleSave, isLoading: isSaveLoading } = useSaveReportPreferencesQuery();
  const { isLoading, data, isSuccess } = useGetReportPreferencesQuery();

  const handleSavePreferences = useCallback(
    async (value: Partial<PreferencesResponseDTO>) => {
      await handleSave({
        ...data,
        ...value,
      });
    },
    [data, handleSave]
  );
  return {
    isSuccess,
    isLoading: isSaveLoading || isLoading,
    handleSave: handleSavePreferences,
    data: data,
  };
};

export default useReportPreferencesHandler;
